module.exports = __webpack_public_path__ + "img/testimonial-54.6112a5cd.jpeg";